/**
 * Configuration for MSAL (Microsoft Authentication Library)
 * Values can be configured via .env variables:
 * - VITE_ENTRA_CLIENT_ID: The Application (client) ID from Azure Portal App Registration
 * - VITE_ENTRA_TENANT_ID: The Directory (tenant) ID (or 'organizations' / 'common')
 */

export const msalConfig = {
  auth: {
    clientId: import.meta.env.VITE_ENTRA_CLIENT_ID || "",
    authority: `https://login.microsoftonline.com/${import.meta.env.VITE_ENTRA_TENANT_ID || "organizations"}`,
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
    navigateToLoginRequestUrl: true,
  },
  cache: {
    cacheLocation: "sessionStorage", // "sessionStorage" is safer against XSS than "localStorage"
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) return;
        // console.debug(message);
      },
      logLevel: 0 // Error only
    }
  }
};

/**
 * Scopes required to query:
 * 1. User profile + usageLocation: User.Read
 * 2. User's own registered MFA methods: UserAuthenticationMethod.Read
 * Note: UserAuthenticationMethod.Read allows users to read their own methods without needing tenant admin consent.
 */
export const loginRequest = {
  scopes: ["User.Read", "UserAuthenticationMethod.Read"]
};

export const graphConfig = {
  graphMeEndpoint: "https://graph.microsoft.com/v1.0/me?$select=id,displayName,givenName,surname,userPrincipalName,mail,jobTitle,usageLocation,preferredLanguage",
  graphMethodsEndpoint: "https://graph.microsoft.com/v1.0/me/authentication/methods"
};

/**
 * Determines whether real MSAL authentication can be used.
 * If no clientId is set or VITE_DEMO_MODE is true, Demo Mode is enabled.
 */
export const isMsalConfigured = () => {
  return Boolean(import.meta.env.VITE_ENTRA_CLIENT_ID && import.meta.env.VITE_ENTRA_CLIENT_ID !== "YOUR_CLIENT_ID_HERE");
};
